import { QueryResult } from '@/types/api/modules/business-intelligence';

export enum ComponentUIState {
    NOT_READY = 'NOT_READY',
    LOADING = 'LOADING',
    READY_WITH_DATA = 'READY_WITH_DATA',
    READY_EMPTY = 'READY_EMPTY',
}

export type Dataset = {
    id: string;
    label: string;
    metrics: string[];
    dimensions: string[];
};

export type DatasetState = {
    datasets: Dataset[];
    loading: boolean;
    componentQueryState: Record<
        string,
        {
            loading: boolean;
            data?: QueryResult;
            error?: string;
            lastFetchedAt?: number;
            requestKey?: string;
        }
    >;
    selectedDataset: Dataset | null;
    loadingDataset: boolean;
    error?: string;
};

export type DatasetActions = {
    fetchDatasets: (params?: any) => Promise<void>;
    queryDatasets: (
        componentId: string,
        query?: any,
        requestKey?: string,
        options?: { force?: boolean },
    ) => Promise<any>;
    invalidateComponentQuery: (componentId: string) => void;
};
